// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// Bootstrap server only: used to look up which backend serves this client
// (instance_config.serverurl). resolveServer() in main.ts then overwrites
// environment.apiUrl / host with the DB value.
let apiUrlString = "serinav3-dev";
export const environment = {
  production: false,
  apiUrl: `https://${apiUrlString}.centralindia.cloudapp.azure.com`,
  // apiUrl:"http://127.0.0.1:8000",
  apiVersion: "apiv1.1",
  host: `${apiUrlString}.serinaplus.com`,
  domain: `ehgdevv3.serinaplus.com`
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
